import React, { useMemo, useState } from "react";
import company from "assets/images/icon/company.png";
import companystatus from "assets/images/icon/company-status.png";
import onboard from "assets/images/icon/onboard.png";
import implementation from "assets/images/icon/implementation.png";
import Table from "../../components/Table";
import Button from "../../components/Button";
import PlusIcon from "assets/images/icon/plus-white.png";
import Input from "../../components/Input";
import search from "assets/images/icon/search-normal.png";
import ToggleSwitch from "../../components/ToggleSwitch";
import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import routes from "constants/routes";
import styles from "./deductions.module.scss";
import { cn, stringMerger } from "utils";
import CompanyLogo from "assets/images/icon/company-logo";
import UsersLogo from "assets/images/icon/users-logo";
import { getMcnDeductColumns } from "./columns";
import { getChildSupportDeductColumns } from "./columns";
import DollarIcon from "assets/images/icon/dollar-icon";
import RupeesIcon from "assets/images/icon/rupees-icon";
import RupeesPocket from "assets/images/icon/rupees-pocket";
import HandshakeIcon from "assets/images/icon/handshake-icon";

const mcnDeductionsData = [];
const childSupportDeductionsData = [];

const companyCards = [
  { title: "Miscellaneous Deductions", count: 0, icon: <DollarIcon /> },
  { title: "Child Support Deductions", count: 0, icon: <RupeesIcon /> },
  { title: "Active Misc Deductions", count: 0, icon: <RupeesPocket /> },
  { title: "Active Child Support", count: 0, icon: <HandshakeIcon /> },
];

function Deductions() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);

  function handleView(details) {
    navigate(`/deductions/view?code=${details.code}`);
  }

  const mcnDeductColumns = useMemo(() => {
    return getMcnDeductColumns();
  }, []);

  const childSupportDeductColumns = useMemo(() => {
    return getChildSupportDeductColumns();
  }, []);

  return (
    <div className={cn("content", styles.deductionContainer)}>
      <div>
        <div style={{ padding: "16px 24px 16px 16px" }}>
          <div className="row mt-4">
            {companyCards?.map((item) => {
              return (
                <Card
                  title={item?.title}
                  count={item?.count}
                  icon={item?.icon}
                  isImage={false}
                />
              );
            })}
          </div>
        </div>
        <div className={styles.tabList}>
          <button
            className={cn(styles.tab, selectedTab === 0 ? styles.active : "")}
            onClick={() => setSelectedTab(0)}
          >
            <CompanyLogo color={selectedTab === 0 ? "#E7730A" : "#5F5F5F"} />
            <p>Miscellaneous Deductions</p>
          </button>
          <button
            className={cn(styles.tab, selectedTab === 1 ? styles.active : "")}
            onClick={() => setSelectedTab(1)}
          >
            <UsersLogo color={selectedTab === 1 ? "#E7730A" : "#5F5F5F"} />
            <p>Child Support Deduction</p>
          </button>
        </div>
        <div className={cn("container-spacing")}>
          <div className="d-flex justify-content-between mt-4 mb-3">
            <div className="d-flex align-items-center gap-3">
              {selectedTab === 0 ? (
                <Button
                  startIcon={<img src={PlusIcon} />}
                  onClick={() =>
                    navigate(
                      stringMerger(
                        routes.DEDUCTIONS.HOME,
                        routes.DEDUCTIONS.ADD_EDIT_MCN_DEDUCTION
                      )
                    )
                  }
                >
                  Add Deduction
                </Button>
              ) : (
                <Button
                  startIcon={<img src={PlusIcon} />}
                  onClick={() =>
                    navigate(
                      stringMerger(
                        routes.DEDUCTIONS.HOME,
                        routes.DEDUCTIONS.ADD_EDIT_CHILD_SUPPORT_DEDUCTION
                      )
                    )
                  }
                >
                  Add Deduction
                </Button>
              )}
              <ToggleSwitch />
            </div>
            <Input
              placeholder="Search by Name, Email, or Id"
              startIcon={search}
              style={{ width: "380px" }}
            />
          </div>
          <Table
            headers={
              selectedTab === 0 ? mcnDeductColumns : childSupportDeductColumns
            }
            data={
              selectedTab === 0 ? mcnDeductionsData : childSupportDeductionsData
            }
            handleView={handleView}
          />
        </div>
      </div>
    </div>
  );
}

export default Deductions;
